<template>
  <div class="preloader-overlay hide-for-print">
    <div class="inner">
      <svg class="preloader__svg" :id="'preloader_' + this._uid" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 60 40"></svg>
    </div>
  </div><!-- /.preloader-overlay -->
</template>

<script>
import SVG from 'svg.js'
import _ from 'lodash'

export default {
  name: 'preloader-overlay',
  data () {
    return {
      canvas: false,
      colors: ['purple', 'red', 'yellow', 'green'],
      lines: [],
      speed: 400,
      strokeWidth: 5,
      width: 60,
      height: 40,
      timer: false
    }
  },
  mounted () {
    this.canvas = SVG('preloader_' + this._uid)
    this.draw()
  },
  destroyed () {
    clearInterval(this.timer)
    this.canvas.remove()
  },
  computed: {
    spaceBetween () {
      return (this.width - this.strokeWidth) / (this.colors.length - 1)
    },
    delayBetweenEach () {
      return this.speed / this.colors.length
    }
  },
  methods: {
    draw () {
      _.each(this.colors, (color, index) => {
        let xPos = (this.strokeWidth / 2 + (this.spaceBetween * index))
        let line = this.canvas
          .line(xPos, this.height, xPos, 0)
          .stroke({ 'width': this.strokeWidth, dasharray: '0,' + this.height })
        line.addClass('svg-stroke--' + color)
        line.delay(this.delayBetweenEach * index)

        this.lines.push(line)
      })

      let currentIndex = 0
      let animateUp = true
      this.timer = setInterval(() => {
        if (currentIndex + 1 > this.lines.length) {
          animateUp = !animateUp
          currentIndex = 0
        }
        if (animateUp) {
          this.animateBarUp(currentIndex)
        } else {
          this.animateBarDown(currentIndex)
        }
        currentIndex++
      }, this.delayBetweenEach)
    },
    animateBarUp (index) {
      this.lines[index]
        .stop()
        .animate(this.speed)
        .stroke({ dasharray: '0,' + this.height })
    },
    animateBarDown (index) {
      this.lines[index]
        .stop()
        .animate(this.speed)
        .stroke({ dasharray: this.height + ',' + this.height })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~@/components/sass/shared/colors';
  @import '~@/components/sass/shared/fonts';

  .preloader-overlay{
    bottom: 0;
    background: transparentize($white, 0.7);
    display: flex; -js-display: flex;
    justify-content: center;
    left: 0;
    min-height: 300px;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 150;
  }

  .preloader__svg{
    margin-top: 200px;
    height: 30px;
    width: 50px;
  }

</style>



// WEBPACK FOOTER //
// src/components/shared/misc/PreloaderOverlay.vue